import { createAction, props } from '@ngrx/store';
import { CalculateReportModel } from '../model/calculate-report.model';

export const CalculatedReportActions = {
  loadCalculatedReport: createAction(
    '[Calculated Report] Load',
    props<{ templateOid: number }>()
  ),
  loadCalculatedReportSuccess: createAction(
    '[Calculated Report] Load Success',
    props<{ data: CalculateReportModel }>()
  ),
  loadCalculatedReportFailure: createAction(
    '[Calculated Report] Load Failure',
    props<{ error: string }>()
  ),
  setCalculatedReportData: createAction(
    '[Calculated Report] Set Data',
    props<{ data: CalculateReportModel; templateOid: number }>()
  ),
  clearCalculatedReportData: createAction(
    '[Calculated Report] Clear Data'
  ),
  resetCalculatedReportStore: createAction(
    '[Calculated Report] Reset Store'
  ),
};
